import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  Section,
  Message,
  Close,
} from 'rebass';

import If from 'frontend/components/If';

import actions from 'frontend/state/actions';
import { selectors as jobSelectors } from 'frontend/state/reducers/simbot/jobs';
import { selectors as flashSelectors } from 'frontend/state/reducers/flash';
import { selectors as userSelectors } from 'frontend/state/reducers/user';

const Simbot = ({ children, flashMessage, dismissFlash, patron }) => ( // eslint-disable-line no-unused-vars
  <Section pb={1} pt={0}>
    <If condition={flashMessage}>
      <Message theme="success" p={1}>
        <Close onClick={dismissFlash} /> {flashMessage}
      </Message>
    </If>
    <Section pt={0} pb={0} mt={1}>
      {children}
    </Section>
  </Section>
);

Simbot.propTypes = {
  children: PropTypes.element.isRequired,
  flashMessage: PropTypes.string,
  dismissFlash: PropTypes.func,
  patron: PropTypes.bool,
};
Simbot.defaultProps = {
  flashMessage: null,
  dismissFlash: () => {},
  patron: false,
};

const mapStateToProps = (state, props) => ({
  jobs: jobSelectors.jobs(state),
  flashMessage: flashSelectors.message(state),
  patron: userSelectors.isPatron(state),
  children: props.children,
});

const mapDispatchToProps = {
  dismissFlash: actions.dismissFlash,
};

export default connect(mapStateToProps, mapDispatchToProps)(Simbot);
